import { getGlobal } from 'lib/contentful';
import { reformatLocaleToContentfulLocale } from 'lib/utils/helpers';
import { hasNewCustomerAccounts } from 'lib/shopify';
import Layout from 'components/layout';
import RegisterSection from 'components/account/registerSection';
import OauthRedirect from 'components/account/oauthRedirect';
import { useSalons } from 'hooks';

export const Register = ({ previewData, locale, globalModules }) => {
  useSalons(locale);
  const newCustomerAccounts = hasNewCustomerAccounts(locale);

  return (
    <Layout
      locale={locale}
      previewData={previewData}
      cookieBar
      pageTitle={globalModules?.translations?.account?.register?.title || 'Register'}
    >
      {newCustomerAccounts ? (
        <OauthRedirect locale={locale} />
      ) : (
        <RegisterSection locale={locale} />
      )}
    </Layout>
  );
};

export async function getStaticProps({ previewData = null, locale }) {
  const globalModules = await getGlobal(reformatLocaleToContentfulLocale(locale));

  const { hasWebshop } = globalModules?.settings.locale;

  if (!hasWebshop)
    return {
      notFound: true,
    };

  return {
    props: {
      previewData,
      locale,
      globalModules,
    },
  };
}

export default Register;
